import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function NotificationPagination({
  total,
  page,
  pageCount,
  onPageChange,
}: {
  total: number;
  page: number;
  pageCount: number;
  onPageChange: (updater: (current: number) => number) => void;
}) {
  return (
    <div className="flex flex-col gap-2 border-t border-border bg-surface-muted px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-[11px] text-muted-foreground">
        {total} notification{total !== 1 ? "s" : ""}
      </p>
      <div className="flex items-center justify-between gap-2 sm:justify-end">
        <Button
          type="button"
          variant="secondary"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange((current) => Math.max(1, current - 1))}
        >
          <ChevronLeft size={13} />
          Précédent
        </Button>
        <span className="text-[11px] text-muted-foreground">
          Page {page} / {pageCount}
        </span>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          disabled={page >= pageCount}
          onClick={() => onPageChange((current) => current + 1)}
        >
          Suivant
          <ChevronRight size={13} />
        </Button>
      </div>
    </div>
  );
}
